import axios from 'axios';

const api = axios.create({
  baseURL: "https://api.colchoes.ind.br/",
});

export default api;
